/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, {useEffect} from 'react'
import {ContentSection, Modal, TitleSection, ModalTitle, Row, Color, Chip} from "trux"
import './SelectCameraDialog.css'

export const SelectCameraDialog = ({modalOpen, setSelectCameraModalOpen, allCameras, selectedCamera, setSelectedCamera, parent }) => {

	const onSelectCamera = (selectedCamera) => {
		setSelectedCamera(selectedCamera);
		setSelectCameraModalOpen(false);
	}

	const compare = (a,b) => {
		let aIdx = cameraSortIndex(a)
		let bIdx = cameraSortIndex(b)
		let delta = aIdx - bIdx
		if (delta === 0)
			delta = a.title.localeCompare(b.title)
		return delta
	}

	const cameraSortIndex = (camera) => {
		if (camera.name === "multi-cam") return 5
		if (camera.name === "tracecam") return 10
		return 20
	}

	useEffect(() => {
		allCameras.sort( compare )
	},[])

	return (
		<Modal
			trkContext={`Select Camera Views Dialog`}
			className="select-camera-views-dialog"
			open={modalOpen}
			onShadeClick={() => setSelectCameraModalOpen(false)}
			parent={parent}
		>
			<TitleSection onCloseClick={() => setSelectCameraModalOpen(false)}>
				<ModalTitle content="Filter camera views"/>
			</TitleSection>
			<ContentSection>
				<Row justifyContent="center" spacingBottom="2">
					<Chip
						key={'all'}
						content={'All cameras'}
						background={selectedCamera === 'all' ? Color.Black : Color.Grey4}
						color={selectedCamera === 'all' ? Color.White2 : Color.Black}
						marginRight="2"
						marginBottom="2"
						fat
						trkAction={`Selected Camera all`}
						onClick={() => onSelectCamera('all')}
					/>
					{allCameras.map(camera => {
						return (
							<Chip
								key={camera.name}
								content={camera.title}
								background={selectedCamera === camera.name ? Color.Black : Color.Grey4}
								color={selectedCamera === camera.name ? Color.White2 : Color.Black}
								marginRight="2"
								marginBottom="2"
								fat
								trkAction={`Selected Camera ${camera.name}`}
								onClick={() => onSelectCamera(camera.name)}
							/>
						)
					})}
				</Row>
			</ContentSection>
		</Modal>
	)

}